import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import "./reports.css"
import { TfiEmail } from "react-icons/tfi";
import { HiOutlinePrinter } from "react-icons/hi2";
import { PiDownloadSimple } from "react-icons/pi";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { BsFileEarmarkPdf, BsFileEarmarkExcel, BsFiletypeCsv } from "react-icons/bs";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import AsyncSelect from 'react-select/async';
import { BarLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import * as XLSX from 'xlsx';

const ItemReports = () => {
    const [subCategoryOptions, setSubCategoryOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [hideZeroAmount, setHideZeroAmount] = useState(false);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const currentDatetimeUTC = new Date().toISOString();
    const [paginationData, setPagination] = useState();
    const [itemOptions, setItemOptions] = useState([]);
    const onCloseModal = () => setEmailModal(false);
    const [cost2main, setCost2main] = useState([]);
    const [allRowData, setAllData] = useState([]);
    const onOpenModal = () => setEmailModal(true);
    const [loading, setLoading] = useState(true);
    const [StockType, setStockType] = useState();
    const [pageSize, setPageSize] = useState(20);
    const [Location, setLocation] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [desPage, setDecPage] = useState(1);
    const [load, setLoad] = useState(false);
    const [cost2, setCost2] = useState([]);
    const [cost1, setCost1] = useState([]);
    const apiService = new ApiService();
    const { precision } = useCurrency();
    const [page, setPage] = useState(1);
    const gridRef = useRef(null);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const [formData, setFormData] = useState({
        itemNo: { label: 'Select ItemNo', value: 'All' },
        ItemDescription: { label: 'Select Item', value: 'All' },
        email: "",
        Category: [{ label: 'Select Category', value: '' }],
        SubCategory: [{ label: 'Select Sub Category', value: '' }],
        StockType: [{ label: 'Select Stock Type', value: "" }],
        Warehouse: [{ label: 'Select Ware House', value: "" }],
        costCenter1: [{ label: 'Select Property', value: "" }],
        costCenter2: [{ label: 'Select Unit', value: "" }],
    });
    useEffect(() => {
        getCat()
        getItems()
    }, []);
    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);

    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemDescription', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async () => {
        if (!hasMore || loader) return;
        setPage(prevPage => prevPage + 1);
        await fetchItemNo("", page + 1);
    };
    const loadMoreDescOptions = async () => {
        if (!hasMore || loader) return;
        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc("", desPage + 1);
    };
    const getCat = async () => {
        let Catparam = `?Active=1`;
        let param = `?isActive=true`
        const categoryResponse = await apiService.getApiParamater("GET_CATEGORY", Catparam);
        setCategoryOptions(categoryResponse?.data?.result);
        const subCategoryResponse = await apiService.getApiParamater("GET_SUB_CATEGORY", Catparam);
        setSubCategoryOptions(subCategoryResponse?.data?.result);
        const stockType = await apiService.getApiParamater("GET_STOCK_TYPE", param);
        setStockType(stockType?.data?.result);
        let res = await apiService.get('GET_WAREHOUSE_MASTER')
        setLocation(res?.data?.result)
        let cost1 = await apiService.get('GET_COST_ONE')
        setCost1([{ value: null, description: 'None' }, ...cost1.data.result]);
        let cost2 = await apiService.get('GET_COST_TWO')
        setCost2([{ value: null, description: 'None' }, ...cost2.data.result]);
        setCost2main([{ value: null, description: 'None' }, ...cost2.data.result]);
    }
    const getItems = async (newPageNo = paginationData?.currentPage) => {
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            if (formData.itemNo.value.itemNo) {
                params.append('ItemNo', formData.itemNo.value.itemNo || '');
            }
            if (formData.itemNo.value.itemDescription) {
                params.append('ItemDescription', formData.itemNo.value.itemDescription || '');
            }
            params.append('Category', formData.Category?.value?.catCode || "0");
            params.append('SubCategory', formData.SubCategory?.value?.subcatcode || "0");
            params.append('StockType', formData.StockType?.value?.stockTypeCode || "0");
            params.append('Warehouse', formData.Warehouse?.label || "0");
            params.append('AsOnDate', currentDatetimeUTC);
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);

            const res = await apiService.getApiParamater('GET_ITEMS_REPORT', `?${params.toString()}`);
            setPagination(res.data.paginationData);
            setRowData(res?.data?.result?.reverse() || []);
            setAllData(res?.data?.result?.reverse() || []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const handleClearFilters = () => {
        setFormData({
            itemNo: { label: 'Select ItemNo', value: 'All' },
            ItemDescription: { label: 'Select Item', value: 'All' },
            email: "",
            Category: [{ label: 'Select Category', value: 'Select Category' }],
            SubCategory: [{ label: 'Select Sub Category', value: "" }],
            StockType: [{ label: 'Select Stock Type', value: "" }],
            Warehouse: [{ label: 'Select Ware House', value: "" }],
            costCenter1: [{ label: 'Select Property', value: "" }],
            costCenter2: [{ label: 'Select Unit', value: "" }],
        });
        setCost2(cost2main)
        getItems()
    }
    const Comparison = [
        { headerName: 'Item Code', field: 'itemNo', suppressMovable: true, width: 120, },
        { headerName: 'Description ', field: 'itemDescription', suppressMovable: true, width: 500 },
        { headerName: 'Category', field: 'category', suppressMovable: true, width: 130 },
        { headerName: 'Sub Category', field: 'subCategory', suppressMovable: true, width: 150 },
        { headerName: 'Stock Type', field: 'stockType', suppressMovable: true, width: 130 },
        { headerName: 'Packing UOM', field: 'baseUnit', suppressMovable: true, width: 130 },
        { headerName: 'Inventory UOM', field: 'unitMeasurement', suppressMovable: true, width: 125 },
        {
            headerName: 'Packing QTY', field: 'qty', suppressMovable: true, width: 130,
            valueFormatter: (params) => params?.value?.toFixed(1)
        },
        { headerName: 'Inventory Qty', field: 'inventoryQty', suppressMovable: true, width: 140 },
        { headerName: 'Warehouse', field: 'warehouseLocation', suppressMovable: true, width: 180 },
        {
            headerName: 'Unit Price', field: 'price', suppressMovable: true, width: 150,
            valueFormatter: (params) => params?.value?.toFixed(precision?.precision || 0)
        },
        {
            headerName: 'Amount', field: 'amount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(precision?.precision || 0)
        },
    ]
    const PDF_COLUMNS = [
        { header: 'Item Code', field: 'itemNo' },
        { header: 'Description', field: 'itemDescription' },
        { header: 'Category', field: 'category' },
        { header: 'Sub Category', field: 'subCategory' },
        { header: 'Packing UOM', field: 'baseUnit' },
        { header: 'Inventory UOM', field: 'unitMeasurement' },
        { header: 'Packing QTY', field: 'qty' },
        { header: 'Inventory Qty', field: 'inventoryQty' },
        { header: 'Warehouse', field: 'warehouseLocation' },
        { header: 'Unit Price', field: 'price' },
        { header: 'Amount', field: 'amount' },
    ];
    const onBtnCSVExport = useCallback(async (formdata, pagedata) => {
        try {
            setLoading(true);

            const params = new URLSearchParams();

            if (formdata?.itemNo?.value?.itemNo) {
                params.append('ItemNo', formdata.itemNo.value.itemNo);
            }
            if (formdata?.itemNo?.value?.itemDescription) {
                params.append('ItemDescription', formdata.itemNo.value.itemDescription);
            }

            params.append('Category', formdata.Category?.value?.catCode || "0");
            params.append('SubCategory', formdata.SubCategory?.value?.subcatcode || "0");
            params.append('StockType', formdata.StockType?.value?.stockTypeCode || "0");
            params.append('Warehouse', formdata.Warehouse?.label || "0");
            params.append('AsOnDate', currentDatetimeUTC);

            params.append('PageNo', 1);
            params.append('PageSize', pagedata?.totalRecords || 10000);

            const res = await apiService.getApiParamater(
                'GET_ITEMS_REPORT',
                `?${params.toString()}`
            );

            const allData = res?.data?.result || [];

            if (allData.length === 0) {
                toast.info("No data found");
                return;
            }

            // ✅ Define columns (clean headers)
            const headers = [
                "Item No",
                "Item Description",
                "Stock Type",
                "Category",
                "Sub Category",
                "Warehouse",
                "Unit",
                "Price",
                "Qty",
                "Amount",
                "Inventory Qty",
                "Base Unit"
            ];
            let data = hideZeroAmount
                ? allData.filter(row => row.qty !== 0)
                : allData;
            const rows = data.map(row => [
                row.itemNo,
                row.itemDescription,
                row.stockType,
                row.category,
                row.subCategory,
                row.warehouseLocation || "",
                row.unitMeasurement,
                row.price ?? 0,
                row.qty ?? 0,
                row.amount ?? 0,
                row.inventoryQty ?? 0,
                row.baseUnit
            ]);

            // ✅ Convert to CSV string
            const csvContent = [
                headers.join(","),
                ...rows.map(r =>
                    r.map(val => `"${String(val).replace(/"/g, '""')}"`).join(",")
                )
            ].join("\n");

            // ✅ Download file
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "itemsReport.csv";
            link.click();

            window.URL.revokeObjectURL(url);

            toast.success("itemsReport.csv downloaded");

        } catch (err) {
            console.error(err);
            toast.error("Export failed");
        } finally {
            setLoading(false);
        }
    }, []);
    const onBtPDFExport = useCallback(async (formdata, pagedata) => {
        setLoading(true);
        const params = new URLSearchParams();

        if (formdata.itemNo?.value?.itemNo) {
            params.append('ItemNo', formdata.itemNo.value.itemNo);
        }
        if (formdata.itemNo?.value?.itemDescription) {
            params.append('ItemDescription', formdata.itemNo.value.itemDescription);
        }

        params.append('Category', formdata.Category?.value?.catCode || "0");
        params.append('SubCategory', formdata.SubCategory?.value?.subcatcode || "0");
        params.append('StockType', formdata.StockType?.value?.stockTypeCode || "0");
        params.append('Warehouse', formdata.Warehouse?.label || "0");
        params.append('AsOnDate', currentDatetimeUTC);

        // fetch all records
        params.append('PageNo', 1);
        params.append('PageSize', pagedata?.totalRecords || 10000);

        const res = await apiService.getApiParamater(
            'GET_ITEMS_REPORT',
            `?${params.toString()}`
        );
        const allData = res?.data?.result || [];
        setAllData(allData)
        let data = hideZeroAmount
            ? allData.filter(row => row.qty !== 0)
            : allData;
        debugger
        if (data.length > 0) {
            const doc = new jsPDF('l', 'mm', 'a4');
            const headers = PDF_COLUMNS.map(col => col.header);
            const rows = data.map(item =>
                PDF_COLUMNS.map(col => item[col.field] ?? '')
            );

            // Add title
            doc.setFontSize(14);
            doc.text('Item Master Report', 14, 10);

            // Add date
            doc.setFontSize(10);
            doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 16);

            // Add table
            doc.autoTable({
                head: [headers],
                body: rows,
                startY: 20,
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                },
                headStyles: {
                    fillColor: [110, 81, 153],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                },
                theme: 'grid',
            });

            // Save PDF
            doc.save('itemsReport.pdf');
            setLoading(false);
            toast.success("itemsReport.pdf downloaded");
        } else {
            toast.info("No data to export");
            setLoading(false);
        }
    }, []);
    const onBtExcelExport = useCallback(async (formdata, pagedata) => {
        try {
            setLoading(true);
            const params = new URLSearchParams();

            if (formdata?.itemNo?.value?.itemNo) {
                params.append('ItemNo', formdata.itemNo.value.itemNo);
            }
            if (formdata?.itemNo?.value?.itemDescription) {
                params.append('ItemDescription', formdata.itemNo.value.itemDescription);
            }

            params.append('Category', formdata.Category?.value?.catCode || "0");
            params.append('SubCategory', formdata.SubCategory?.value?.subcatcode || "0");
            params.append('StockType', formdata.StockType?.value?.stockTypeCode || "0");
            params.append('Warehouse', formdata.Warehouse?.label || "0");
            params.append('AsOnDate', currentDatetimeUTC);

            params.append('PageNo', 1);
            params.append('PageSize', pagedata?.totalRecords || 10000);

            const res = await apiService.getApiParamater(
                'GET_ITEMS_REPORT',
                `?${params.toString()}`
            );

            const allData = res?.data?.result || [];
            if (allData.length === 0) {
                toast.info("No data found");
                return;
            }
            let data = hideZeroAmount
                ? allData.filter(row => row.qty !== 0)
                : allData;
            // Map data to sheet
            const worksheetData = data.map(row => ({
                "Item No": row.itemNo,
                "Item Description": row.itemDescription,
                "Stock Type": row.stockType,
                "Category": row.category,
                "Sub Category": row.subCategory,
                "Warehouse": row.warehouseLocation || "",
                "Unit": row.unitMeasurement,
                "Price": row.price ?? 0,
                "Qty": row.qty ?? 0,
                "Amount": row.amount ?? 0,
                "Inventory Qty": row.inventoryQty ?? 0,
                "Base Unit": row.baseUnit,
            }));

            // Create worksheet and workbook
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Items Report");

            // Generate buffer
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

            // Save file
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'itemsReport.xlsx';
            link.click();
            window.URL.revokeObjectURL(url);

            toast.success("itemsReport.xlsx downloaded");
        } catch (err) {
            console.error(err);
            toast.error("Export failed");
        } finally {
            setLoading(false);
        }
    }, []);
    const SendEmail = async () => {
        try {

            setLoad(true)
            if (!formData.email) {
                toast.warning("Enter User Email to send Report")
                setLoad(false)
                return;
            }
            const params = new URLSearchParams();

            if (formData.itemNo?.value?.itemNo) {
                params.append('ItemNo', formData.itemNo.value.itemNo);
            }
            if (formData.itemNo?.value?.itemDescription) {
                params.append('ItemDescription', formData.itemNo.value.itemDescription);
            }

            params.append('Category', formData.Category?.value?.catCode || "0");
            params.append('SubCategory', formData.SubCategory?.value?.subcatcode || "0");
            params.append('StockType', formData.StockType?.value?.stockTypeCode || "0");
            params.append('Warehouse', formData.Warehouse?.label || "0");
            params.append('AsOnDate', currentDatetimeUTC);

            // fetch all records
            params.append('PageNo', 1);
            params.append('PageSize', paginationData?.totalRecords || 10000);

            const res = await apiService.getApiParamater(
                'GET_ITEMS_REPORT',
                `?${params.toString()}`
            );
            const allData = res?.data?.result || [];
            let data = hideZeroAmount
                ? allData.filter(row => row.qty !== 0)
                : allData;

            const requestBody = {
                toEmail: formData.email,
                subject: "Item Stock Report",
                body: `
    <div className='printhead2 mb-5 px-4'>
      <table>
        <thead className='dynoTable' style='background-color: #6E5199; color: #fff;'>
          <tr>
            <th>Item Code</th>
            <th>Description</th>
            <th>Category</th>
            <th>Sub Category</th>
            <th>Stock Type</th>
            <th>Packing UOM</th>
            <th>Inventory UOM</th>
            <th>Packing QTY</th>
            <th>Inventory Qty</th>
            <th>Warehouse</th>
            <th>Price</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          ${data && data.length > 0 ? data.map((row, index) => `
            <tr key=${index}>
              <td className='m-0 p-0'><input style='width: 100px;' className='p-2' type='text' value='${row.itemNo ?? '---'}' disabled /></td>
              <td className='m-0 p-0'><input style='width: 300px;' className='p-2' disabled value='${row.itemDescription ?? '---'}' /></td>
              <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.category ?? '---'}' /></td>
              <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.subCategory ?? '---'}' /></td>
              <td className='m-0 p-0'><input style='width: 80px;' className='p-2' disabled value='${row.stockType ?? '---'}' /></td>
              <td className='m-0 p-0'><input style='width: 150px;' className='p-2' disabled value='${row.baseUnit ?? '---'}' /></td>
              <td className='m-0 p-0'><input style='width: 120px;' className='p-2' disabled value='${row.unitMeasurement ?? '---'}' /></td>
              <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.qty ?? 0}' /></td>
              <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.inventoryQty ?? '---'}' disabled /></td>
              <td className='m-0 p-0'><input style='width: 150px;' className='p-2' type='text' value='${row.warehouseLocation ?? '---'}' disabled /></td>
              <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.price ?? 0}' disabled /></td>
              <td className='m-0 p-0'><input className='p-2 w-100' type='text' value='${row.amount?.toFixed(precision?.precision || 0) ?? '0'}' disabled /></td>
            </tr>
          `).join('') : `
            <tr>
              <td colspan="12" style="text-align: center;">No data available</td>
            </tr>
          `}
        </tbody>
      </table>
    </div>
  `
            }
            const response = await apiService.post("SEND_EMAIL", requestBody);
            if (response.status === 200) {
                onCloseModal()
                toast.success("Email send successfully")
                setLoad(false)
                handleClearFilters()
            }
            setLoad(false)
        } catch (error) {
            console.error('Error:', error);
            setLoad(false)
        }
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "itemNo" || name === "ItemDescription") {
            setFormData({
                ...formData,
                itemNo: value ? { label: value.value.itemNo, value: value.value } : null,
                ItemDescription: value ? { label: value.value.itemDescription, value: value.value } : null,
            });
        } else if (name === "costCenter1") {
            let param = `?CostCenter1=${value?.label}`
            let cost2 = await apiService.getApiParamater('GET_COST_TWO', param)
            setFormData(prev => ({ ...prev, [name]: value }));
            if (cost2?.data?.result) {
                setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
            } else {
                setCost2([])
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };
    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-8'>
                    <div className='row' >
                        <div className='col'>
                            <AsyncSelect
                                cacheOptions
                                value={formData.itemNo}
                                options={itemOptions}
                                loadOptions={loadOptions}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'itemNo', value: selectedOption })}
                                defaultOptions={itemOptions}
                                onMenuScrollToBottom={loadMoreOptions}
                            />
                        </div>
                        <div className='col'>
                            <AsyncSelect
                                cacheOptions
                                value={formData.ItemDescription}
                                options={descriptionOptions}
                                loadOptions={loadDescOptions}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'ItemDescription', value: selectedOption })}
                                className="w-100 p-0"
                                defaultOptions={descriptionOptions}
                                onMenuScrollToBottom={loadMoreDescOptions}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.Category}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'Category', value: selectedOption })}
                                options={categoryOptions?.map((CatOpt) => ({ value: CatOpt, label: CatOpt?.catName }))}
                            />
                        </div>
                    </div>
                    <div className='row py-2'  >
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.SubCategory}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'SubCategory', value: selectedOption })}
                                options={subCategoryOptions?.map((SubCatOpt) => ({ value: SubCatOpt, label: SubCatOpt?.subcatname }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.StockType}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'StockType', value: selectedOption })}
                                options={StockType?.map((Stock) => ({ value: Stock, label: Stock?.stockTypeName }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.Warehouse}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'Warehouse', value: selectedOption })}
                                options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.costCenter1}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter1', value: selectedOption })}
                                options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.costCenter2}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter2', value: selectedOption })}
                                options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                            />
                        </div>
                        <div className="col d-flex align-items-center gap-2 px-2">
                            <input
                                type="checkbox"
                                style={{ width: "20px", height: "20px" }}
                                checked={hideZeroAmount}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setHideZeroAmount(checked);
                                    if (checked) {
                                        setRowData(allRowData.filter(r => Number(r.qty) !== 0));
                                    } else {
                                        setRowData(allRowData);
                                    }
                                }}
                            />
                            <label className="mb-0">Hide Zero Qty</label>
                        </div>
                    </div>
                </div>
                <div className='col'></div>
                <div className='col-3 '>
                    <div onClick={() => getItems()} className='mainbtnGry flex-end gap-2'>
                        <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Search</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Item Master Report</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2' >
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={() => onBtExcelExport(formData, paginationData)} className='gap-3 d-flex center'><BsFileEarmarkExcel /><div>Export Excel</div></DropdownItem>
                                <DropdownItem onClick={() => onBtnCSVExport(formData, paginationData)} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                <DropdownItem onClick={() => onBtPDFExport(formData, paginationData)} className='gap-3 d-flex center'><BsFileEarmarkPdf /><div>Export PDF</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div className='mainbtnRed flex-end '><HiOutlinePrinter size={25} /></div>
                    <div className='mainbtn flex-end gap-1' onClick={onOpenModal}>
                        <div className='center'><TfiEmail size={25} /></div>
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 550 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            enableFilter={true}
                            floatingFilter={true}
                            rowSelection={'single'}
                            columnDefs={Comparison}
                            suppressExcelExport={true}
                            ref={gridRef}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} pagination={paginationData} getItems={getItems} setPageSize={setPageSize} />
            </div>
            <Modal size="md"
                show={emailModal} onHide={() => setEmailModal(false)}
                backdrop="static"
                contentLabel='Email Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Send Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input
                            type='email'
                            className="form-Input w-100"
                            id="validationCustom02"
                            value={formData.email}
                            name="email"
                            onChange={handleInputChange}
                            placeholder='Enter Email'
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    {load === true ?
                        <button className='mainbtnRed'>...</button> :
                        <button className='mainbtnRed' onClick={SendEmail}>Save</button>
                    }
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default ItemReports;